if (!customElements.get('dx-niti-order')) {
  customElements.define('dx-niti-order', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.rows = Array.from(this.querySelectorAll('tbody tr'));
      this.selects = Array.from(this.querySelectorAll('select'));
      this.form = this.querySelector('form[data-order-form]');
      this.button = this.querySelector('button[type="submit"]');
      this.sticky = this.querySelector('[data-order-sticky]');
      this.stickyButton = this.querySelector('[data-sticky-add]');
      this.status = this.querySelector('[data-status]');
      this.money = new Intl.NumberFormat(this.dataset.locale, {style: 'currency', currency: this.dataset.currency});
      const options = {signal: this.controller.signal};
      this.selects.forEach(select => select.addEventListener('change', () => this.update(), options));
      this.form.addEventListener('input', () => this.update(), options);
      this.form.addEventListener('submit', event => this.submit(event), options);
      const selected = this.rows.find(row => row.querySelector('input').dataset.id === this.dataset.selected);
      if (selected) this.selects.forEach(select => { select.value = selected.dataset[`option${select.dataset.option}`]; });
      this.stickyButton?.addEventListener('click', () => this.form.requestSubmit(), options);
      window.addEventListener('scroll', () => this.updateSticky(), {...options, passive: true});
      window.addEventListener('resize', () => this.updateSticky(), options);
      this.nativeControls = Array.from(document.querySelectorAll('[data-dx-native]')).filter(node => node.dataset.dxNative === this.dataset.section);
      this.nativeControls.forEach(node => { node.hidden = true; });
      this.hidden = false;
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.nativeControls?.forEach(node => { node.hidden = false; });
    }
    update() {
      let quantity = 0;
      let cents = 0;
      const review = this.querySelector('[data-review]');
      review.replaceChildren();
      this.rows.forEach(row => {
        row.hidden = this.selects.some(select => row.dataset[`option${select.dataset.option}`] !== select.value);
        const input = row.querySelector('input');
        const count = Number(input.value);
        const min = Number(input.dataset.min);
        const step = Number(input.dataset.step);
        const max = input.max ? Number(input.max) : Infinity;
        const valid = Number.isSafeInteger(count) && count >= min && count <= max && count > 0 && count % step === 0 && !input.disabled;
        const listForm = this.querySelector(`#dx-list-${CSS.escape(this.dataset.section)}-${input.dataset.id}`);
        if (listForm) listForm.querySelector('[name="quantity"]').value = valid ? String(count) : '0';
        if (valid) {
          quantity += count;
          cents += count * Number(row.dataset.price);
          const item = document.createElement('li');
          item.textContent = `${count} × ${row.dataset.title}`;
          if (listForm) {
            const save = document.createElement('button');
            save.type = 'button';
            save.className = 'dx-order-list-save';
            save.dataset.dlSave = '';
            save.dataset.form = listForm.id;
            save.dataset.handle = this.dataset.handle;
            save.textContent = this.dataset.listLabel;
            save.setAttribute('aria-label', `${this.dataset.listLabel}: ${row.dataset.title}`);
            save.disabled = count > 9999 || this.busy;
            item.append(save);
          }
          review.append(item);
        }
      });
      this.querySelector('[data-total]').textContent = `${quantity} ${this.dataset.count} · ${this.money.format(cents / 100)}`;
      this.button.disabled = !quantity || this.busy;
      if (this.stickyButton) this.stickyButton.disabled = this.button.disabled;
      const stickyTotal = this.querySelector('[data-sticky-total]');
      if (stickyTotal) stickyTotal.textContent = this.querySelector('[data-total]').textContent;
      this.updateSticky();
    }
    updateSticky() {
      if (!this.sticky) return;
      const footer = document.querySelector('#footer, footer');
      const footerVisible = footer && window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - footer.offsetHeight;
      this.sticky.hidden = this.getBoundingClientRect().bottom >= 0 || this.button.disabled || Boolean(footerVisible);
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy) return;
      const items = [];
      for (const row of this.rows) {
        const input = row.querySelector('input');
        const quantity = Number(input.value);
        const min = Number(input.dataset.min);
        const step = Number(input.dataset.step);
        const max = input.max ? Number(input.max) : Infinity;
        if (!Number.isSafeInteger(quantity) || quantity < 0 || (quantity > 0 && (input.disabled || quantity < min || quantity > max || quantity % step !== 0))) {
          this.selects.forEach(select => { select.value = row.dataset[`option${select.dataset.option}`]; });
          this.update();
          input.focus();
          this.status.textContent = this.dataset.error;
          return;
        }
        if (quantity) items.push({id: Number(input.dataset.id), quantity});
      }
      if (!items.length) { this.status.textContent = this.dataset.empty; return; }
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = '';
      this.update();
      try {
        const root = window.Shopify.routes.root;
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items, sections: ['main-cart', 'cart-drawer', 'cart-bubble'], sections_url: window.location.pathname})
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error('cart');
        this.rows.forEach(row => { row.querySelector('input').value = '0'; });
        this.status.textContent = this.dataset.success;
        const nativeForm = document.querySelector(`product-form[data-section="${CSS.escape(this.dataset.section)}"]`);
        if (nativeForm?.renderContents && ['main-cart', 'cart-drawer', 'cart-bubble'].every(key => typeof data.sections?.[key] === 'string')) {
          nativeForm.renderContents(data);
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
        }
        for (const item of data.items || []) {
          document.dispatchEvent(new CustomEvent('cart:item-added', {detail: {product: item, quantity: items.find(requested => requested.id === item.variant_id)?.quantity || 1, context: 'product'}}));
        }
        document.getElementById('Cart-Drawer')?.open?.();
      } catch (error) {
        this.status.textContent = this.dataset.error;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        this.update();
      }
    }
  });
}
